import { SvgIconBold, SvgIconLight, SvgIconRegular } from 'src/ui/common/atoms/svg-icon/svg-icon.types';

interface IObjectKeys {
  regular: { [key: string]: SvgIconRegular['icon'] },
  bold: { [key: string]: SvgIconBold['icon'] | null },
  light: { [key: string]: SvgIconLight['icon'] },
}

const IMAGE = 'image';
const ANIMATION = 'animation';
const VIDEO = 'video';
const MEDIA = 'media';
const AUDIO = 'audio';
const DDD = '3d';
const OTHER = 'other';

const EXTENSIONS = {
    regular: {
        jpg: IMAGE,
        jpeg: IMAGE,
        webp: IMAGE,
        png: IMAGE,
        gif: ANIMATION,
        mp4: VIDEO,
        mpeg: VIDEO,
        mp3: AUDIO,
        glb: DDD,
    },
    bold: {
        jpg: null,
        jpeg: null,
        webp: null,
        png: null,
        gif: null,
        mp4: MEDIA,
        mpeg: MEDIA,
        mp3: AUDIO,
        glb: DDD,
    },
    light: {}
} as IObjectKeys;

export const getExtFromUrl = (url: string) => {
    const regex = /(?:\.([^.]+))?$/;
    const [, extension] = regex.exec(url) || [];
    return extension;
};

export const getTokenTypeIcon = ({ type = '', name = '', fileUrl, iconVariant = 'regular' }: {type?: string, name?: string, fileUrl?: string, iconVariant?: 'regular' | 'bold' | 'light'}) => {
    if(!type && !name && fileUrl) {
        const extension =  getExtFromUrl(fileUrl);
        return extension && extension in EXTENSIONS[iconVariant] ? EXTENSIONS[iconVariant][extension] : OTHER;
    }
    if(type.includes('image/gif')) {
        return ANIMATION;
    }
    if(type.includes('image')) {
        return IMAGE;
    }
    if(type.includes('video/mp4')) {
        return VIDEO;
    }
    if(type.includes('audio/mpeg')) {
        return AUDIO;
    }
    const isGlb = !type && name.split('.').pop() === 'glb';
    if(isGlb) {
        return DDD;
    }
    return OTHER;
};